import { getCookie } from './cookies/cookies';
import { CookieKey } from './cookies/cookie-keys.const';

declare const ENVIRONMENT: string;
declare const API_URL: string;
declare const API_URL_EU: string;
declare const ACCOUNT_URL: string;
declare const ACCOUNT_URL_EU: string;
declare const STATIC_HOST_URL: string;
declare const STATIC_HOST_URL_EU: string;
declare const SERVER_URL: string;
declare const SERVER_URL_EU: string;
declare const WEBSITE_URL: string;
declare const WEBSITE_URL_EU: string;
declare const SENDBIRD_APP_ID: string;
declare const SENDBIRD_EU_APP_ID: string;
declare const GOOGLE_MAPS_KEY: string;
declare const GOOGLE_MAPS_KEY_EU: string;
declare const STATSIG_CLIENT_ID: string;
declare const STATSIG_PROXY_URL: string;

export const environment = {
  ENVIRONMENT,
  API_URL,
  API_URL_EU,
  ACCOUNT_URL,
  ACCOUNT_URL_EU,
  STATIC_HOST_URL,
  STATIC_HOST_URL_EU,
  SERVER_URL,
  SERVER_URL_EU,
  WEBSITE_URL,
  WEBSITE_URL_EU,
  SENDBIRD_APP_ID,
  SENDBIRD_EU_APP_ID,
  GOOGLE_MAPS_KEY,
  GOOGLE_MAPS_KEY_EU,
  STATSIG_CLIENT_ID,
  STATSIG_PROXY_URL,
};

export enum ENV {
  LOCAL = 'local',
  LOCAL_PREVIEW = 'localPreview',
  PREVIEW = 'preview',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

export function isLocal(): boolean {
  return environment.ENVIRONMENT === ENV.LOCAL;
}

export function isLocalPreview(): boolean {
  return environment.ENVIRONMENT === ENV.LOCAL_PREVIEW;
}

export function isAnyLocal(): boolean {
  return isLocal() || isLocalPreview();
}

export function isPreview(): boolean {
  return environment.ENVIRONMENT === ENV.PREVIEW;
}

export function isStaging(): boolean {
  return environment.ENVIRONMENT === ENV.STAGING;
}

export function isProduction(): boolean {
  return environment.ENVIRONMENT === ENV.PRODUCTION;
}

export function isEuDomain(): boolean {
  try {
    const url = new URL(environment.STATIC_HOST_URL_EU);
    let staticHostUrl: any = url.hostname;
    staticHostUrl = staticHostUrl.split('.');
    staticHostUrl.shift(); // remove the 'app.' part of URL
    staticHostUrl = staticHostUrl.join('.');
    return location.hostname.endsWith(staticHostUrl);
  } catch (err) {
    return false;
  }
}

export function getRegion(): string {
  return isEuDomain() ? 'eu' : 'us';
}

export function getApiUrl(): string {
  return isEuDomain() ? environment.API_URL_EU : environment.API_URL;
}

export function getAccountUrl(): string {
  return isEuDomain() ? environment.ACCOUNT_URL_EU : environment.ACCOUNT_URL;
}

export function getServerUrl(): string {
  return isEuDomain() ? environment.SERVER_URL_EU : environment.SERVER_URL;
}

export function getStaticHostUrl() {
  return isEuDomain() ? environment.STATIC_HOST_URL_EU : environment.STATIC_HOST_URL;
}

export function getWebsiteUrl() {
  return isEuDomain() ? environment.WEBSITE_URL_EU : environment.WEBSITE_URL;
}

export function getSendBirdAppId(): string {
  return isEuDomain() ? environment.SENDBIRD_EU_APP_ID : environment.SENDBIRD_APP_ID;
}

export function getGoogleMapsKey(): string {
  return isEuDomain() ? environment.GOOGLE_MAPS_KEY_EU : environment.GOOGLE_MAPS_KEY;
}

export function getAuthToken(): string {
  const authToken = isEuDomain() ? getCookie(CookieKey.AUTH_TOKEN_EU) : getCookie(CookieKey.AUTH_TOKEN_NA);
  return authToken || getCookie(CookieKey.AUTH_TOKEN);
}

export function getAuthTokenKey(): CookieKey {
  let key: CookieKey = CookieKey.AUTH_TOKEN;

  if (isEuDomain() && getCookie(CookieKey.AUTH_TOKEN_EU)) {
    key = CookieKey.AUTH_TOKEN_EU;
  } else if (getCookie(CookieKey.AUTH_TOKEN_NA)) {
    key = CookieKey.AUTH_TOKEN_NA;
  }

  return key;
}

export function getCiamAuthToken() {
  const ciamAuthToken = isEuDomain() ? getCookie(CookieKey.CIAM_AUTH_TOKEN_EU) : getCookie(CookieKey.CIAM_AUTH_TOKEN_NA);
  return ciamAuthToken || getCookie(CookieKey.CIAM_AUTH_TOKEN);
}
